export function getDisplayName(): string {
       // Uses the pipeline-driven DISPLAY_NAME
       const name = process.env.REACT_APP_DISPLAY_NAME;
       // Otherwise fall back to DEFAULT
       return (
       name
       || process.env.REACT_APP_DISPLAY_NAME_DEFAULT
       || "NaaS by Telecom District & CTX"
       );
}
  